import { Maybe } from "@flockcover/flock-svc-core-types"
import { Analytics } from "../types"

type VehicleType = "car" | "light" | "heavy" | undefined

export type TripVehicle = {
  vrn: string
  name: string
  vehicleType: VehicleType
  currentPeriod: Maybe<Analytics>
  previousPeriodScore: Maybe<number>
  totalSafetyScore: Maybe<number>
  totalDistance: Maybe<number>
}

const tripVehicleSortKeyValues = [
  `currentPeriod.distanceKm`,
  `currentPeriod.driverRanking`,
  `currentPeriod.riskScore`,
  `total.distanceKm`,
  `total.driverRanking`,
  `total.riskScore`,
  `vrn`,
] as const
export const tripVehicleSortKeyFeValues = [`vrn`, `vehicleScore`, `currentPeriodDistance`] as const

export type TripVehicleSortKeys = (typeof tripVehicleSortKeyValues)[number]
export type TripVehicleSortKeysFE = (typeof tripVehicleSortKeyFeValues)[number]

export const tripVehicleSortKeysMap = new Map<TripVehicleSortKeysFE, TripVehicleSortKeys>([
  [`vrn`, `vrn`],
  [`vehicleScore`, `currentPeriod.riskScore`],
  [`currentPeriodDistance`, `currentPeriod.distanceKm`],
])
